import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
const styles = cssMap({
	noListItemsMessageWrapper: {
		maxWidth: '90%',
	},
});
export const NoListItemsMessage = ({ text }: { text: string }): React.JSX.Element => {
	return (
		<Box xcss={styles.noListItemsMessageWrapper}>
			<Text size="small" color="color.text.subtlest">
				{text}
			</Text>
		</Box>
	);
};
